import { __exports as a } from "../../../../../../../../_virtual/t_global_breakpoint_2xl2.js";
var r;
function _() {
  return r ? a : (r = 1, function(l) {
    l.__esModule = !0, l.t_global_breakpoint_2xl = {
      name: "--pf-t--global--breakpoint--2xl",
      value: "90.625rem",
      var: "var(--pf-t--global--breakpoint--2xl)"
    }, l.default = l.t_global_breakpoint_2xl;
  }(a), a);
}
export {
  _ as __require
};
